import React from 'react';
import LegalPage from './LegalPage';
import { PRIVACY_MD } from './legalContent';

const PrivacyPolicy = () => (
  <LegalPage markdown={PRIVACY_MD} />
);

export default PrivacyPolicy;
